import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  logoAlt: {
    id: 'portal.components.header.logo.alt',
    defaultMessage: 'Logo Lockup',
    description: 'Header logo alt text',
  },
  about: {
    id: 'portal.components.header.about.link.text',
    defaultMessage: 'About',
    description: 'Header About link text',
  },
  overview: {
    id: 'portal.components.header.overview.link.text',
    defaultMessage: 'Overview',
    description: 'Header Overview link text',
  },
  broughtToYouBy: {
    id: 'portal.components.header.broughtToYouBy.link.text',
    defaultMessage: 'Brought to you by',
    description: 'Header Brought to you by link text',
  },
  presentedBy: {
    id: 'portal.components.header.presentedBy.link.text',
    defaultMessage: 'Presented by',
    description: 'Header Presented by link text',
  },
  modules: {
    id: 'portal.components.header.modules.link.text',
    defaultMessage: 'Modules',
    description: 'Header Modules link text',
  },
  faq: {
    id: 'portal.components.header.faq.link.text',
    defaultMessage: 'FAQ',
    description: 'Header FAQ link text',
  },
  contact: {
    id: 'portal.components.header.contact.link.text',
    defaultMessage: 'Contact',
    description: 'Header Contact link text',
  },
  login: {
    id: 'portal.components.header.login.link.text',
    defaultMessage: 'Login',
    description: 'Header Login link text',
  },
  profile: {
    id: 'portal.components.header.profile.link.text',
    defaultMessage: 'Profile',
    description: 'Header Profile link text',
  },
  dashboard: {
    id: 'portal.components.header.dashboard.link.text',
    defaultMessage: 'Dashboard',
    description: 'Header Dashboard link text',
  },
  logout: {
    id: 'portal.components.header.logout.link.text',
    defaultMessage: 'Logout',
    description: 'Header Logout link text',
  },
  cohorts: {
    id: 'portal.components.header.cohorts.link.text',
    defaultMessage: 'Cohorts',
    description: 'Header Cohorts link text shown to an anonymous visitor',
  },
  myCohorts: {
    id: 'portal.components.header.myCohorts.link.text',
    defaultMessage: 'My Cohorts',
    description: 'Header Cohorts link text shown to a signed-in user, consistent with the other personal pages',
  },
});

export default messages;
